(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ac-rev:not([data-ac-listo])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.dataset.acListo = '1'; el.classList.add('ac-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('ac-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { el.dataset.acListo = '1'; io.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll('[data-ac-faq]:not([data-ac-listo])').forEach(function (lista) {
      lista.dataset.acListo = '1';
      lista.addEventListener('click', function (ev) {
        var b = ev.target.closest('.ac-faq__b');
        if (!b || !lista.contains(b)) return;
        var item = b.parentElement;
        var caja = item.querySelector('.ac-faq__r');
        var abierto = item.classList.contains('ac-abierto');

        lista.querySelectorAll('.ac-faq__item.ac-abierto').forEach(function (otro) {
          if (otro === item) return;
          otro.classList.remove('ac-abierto');
          otro.querySelector('.ac-faq__b').setAttribute('aria-expanded', 'false');
          otro.querySelector('.ac-faq__r').style.maxHeight = '0px';
        });

        if (abierto) {
          item.classList.remove('ac-abierto');
          b.setAttribute('aria-expanded', 'false');
          caja.style.maxHeight = '0px';
        } else {
          item.classList.add('ac-abierto');
          b.setAttribute('aria-expanded', 'true');
          caja.style.maxHeight = caja.scrollHeight + 'px';
        }
      });
    });
  }


  // El menu movil de Horizon es un <details>. Con los enlaces de ancla
  // (#formula, #ritual) no navegaba, asi que el cajon se quedaba abierto
  // y la pagina no bajaba. Lo cerramos y bajamos nosotros.
  function cerrarMenuMovil() {
    document.querySelectorAll('details[open]').forEach(function (d) {
      if (d.querySelector('.menu-drawer, .menu-drawer__navigation')) d.removeAttribute('open');
    });
    document.querySelectorAll('dialog[open]').forEach(function (d) {
      if (d.querySelector('.menu-drawer, .menu-drawer__navigation')) { try { d.close(); } catch (e) {} }
    });
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden');
  }

  function initAnclas() {
    if (document.documentElement.dataset.acAnclas === '1') return;
    document.documentElement.dataset.acAnclas = '1';
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var a = t.closest('a[href*="#"]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var i = href.indexOf('#');
      if (i < 0) return;
      var id = href.slice(i + 1);
      if (!id || id === 'MainContent') return;
      var ruta = href.slice(0, i);
      if (ruta && ruta !== '/' && ruta !== location.pathname) return;
      if (ruta === '/' && location.pathname !== '/') return;
      var destino = document.getElementById(id);
      if (!destino) return;

      // Cerramos el cajon del menu y dejamos que el navegador haga el salto
      // de forma nativa: es lo mas fiable, y el hueco de la cabecera fija lo
      // resuelve scroll-margin-top desde el CSS.
      cerrarMenuMovil();

      // Red de seguridad: si a los 350 ms no se ha movido nada, lo hacemos aqui.
      var cont = document.querySelector('.page-wrapper');
      var antes = cont ? cont.scrollTop : window.scrollY;
      window.setTimeout(function () {
        var ahora = cont ? cont.scrollTop : window.scrollY;
        if (Math.abs(ahora - antes) < 12) {
          try { destino.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); }
          catch (e) { destino.scrollIntoView(true); }
        }
      }, 350);
    }, true);
  }

  // En contacto, el campo "como es tu piel" solo aparece si el motivo
  // elegido es el que este configurado (por defecto, dudas del serum).
  function initCampoPiel() {
    document.querySelectorAll('[data-ac-motivo]:not([data-ac-listo])').forEach(function (sel) {
      sel.dataset.acListo = '1';
      var form = sel.closest('form');
      var caja = form ? form.querySelector('[data-ac-piel]') : null;
      if (!caja) return;
      var abre = (sel.dataset.acAbre || '').trim().toLowerCase();
      function repasar() {
        var coincide = abre !== '' && sel.value.trim().toLowerCase() === abre;
        if (coincide) {
          caja.hidden = false;
        } else {
          caja.hidden = true;
          var s2 = caja.querySelector('select');
          if (s2) s2.value = '';
        }
      }
      sel.addEventListener('change', repasar);
      repasar();
    });
  }

  function init() { initReveal(); initFaq(); initAnclas(); initCampoPiel(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.ac-faq__item.ac-abierto .ac-faq__r').forEach(function (c) {
      c.style.maxHeight = c.scrollHeight + 'px';
    });
  });
})();
